<template>
  <div class="min-h-screen custom-filter-page">
    <!-- Header -->
    <header v-if="showHeader" class="bg-white shadow-sm border-b">
      <div class="mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-4">
            <img
              src="https://uptodatewebdesign.s3.eu-west-3.amazonaws.com/uploads/icon-1741669842731.png"
              alt="SelectAir"
              class="w-12 h-12 object-contain"
            />
            <div>
              <h1 class="text-2xl font-bold text-gray-900">
                Crematorium Producten
              </h1>
              <p class="text-gray-600 mt-1">Vind jouw perfecte product</p>
            </div>
          </div>
          
          <div class="flex items-center gap-4">
            <router-link
              v-if="showAgentFinder"
              to="/agent-finder"
              class="flex items-center gap-2 px-4 py-2 text-theme border border-theme rounded-lg hover:bg-theme hover:text-white transition-colors"
            >
              <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span class="hidden sm:block">Vind reisagent</span>
            </router-link>
          </div>
        </div>
      </div>
    </header>

    <div class="mx-auto">
      <div class="flex flex-col xl:flex-row gap-8">
        <!-- Mobile Filter Toggle Button -->
        <div class="xl:hidden mb-4">
          <button
            @click="toggleMobileFilters"
            class="w-full flex items-center justify-center gap-2 px-4 py-3 bg-theme text-white rounded-lg hover:bg-theme-hover transition-colors"
          >
            <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Producten & Filters
            <span class="bg-white bg-opacity-20 text-xs px-2 py-1 rounded-full">
              {{ activeFilterCount }}
            </span>
          </button>
        </div>

        <!-- Filters Sidebar -->
        <div class="relative">
          <!-- Mobile overlay -->
          <div
            v-if="showMobileFilters"
            class="fixed inset-0 bg-black bg-opacity-50 z-40 xl:hidden"
            @click="closeMobileFilters"
          ></div>
          
          <!-- Sidebar -->
          <div
            :class="[
              'w-full xl:w-80 flex-shrink-0 transition-transform duration-300 ease-in-out',
              'xl:relative xl:transform-none xl:z-auto',
              showMobileFilters 
                ? 'fixed top-0 left-0 h-full bg-white z-50 transform translate-x-0 overflow-y-auto' 
                : 'xl:block hidden xl:translate-x-0 -translate-x-full'
            ]"
          >
            <!-- Mobile close button -->
            <div class="xl:hidden flex justify-between items-center p-4 border-b bg-gray-50">
              <h3 class="text-lg font-semibold text-gray-900">Filters</h3>
              <button
                @click="closeMobileFilters"
                class="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-200 rounded-full transition-colors"
              >
                <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <FilterSidebar
              :filters="filters"
              :vacations="vacations"
              @filter-change="onFilterChange"
              @clear-filters="clearAllFilters"
            />
          </div>
        </div>

        <!-- Results Area -->
        <div class="flex-1 min-w-0">
          <!-- Results Header -->
          <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
            <div
              class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4"
            >
                          <div>
              <h2 class="text-xl font-semibold text-gray-900">
                {{ displayVacationCount }} producten gevonden
              </h2>
              <p class=" text-gray-600 mt-1">
                {{ activeFiltersText }}
              </p>
            </div>
              <div class="flex items-center space-x-4">
                <label class="text-gray-700 flex items-center gap-2">
                  Sorteren op:
                  <svg class="h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </label>
                <select
                  v-model="sortBy"
                  class="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-theme focus:border-transparent appearance-none bg-white pr-8 relative"
                  style="background-image: url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 fill=%22none%22 viewBox=%220 0 24 24%22 stroke=%22%239CA3AF%22%3E%3Cpath stroke-linecap=%22round%22 stroke-linejoin=%22round%22 stroke-width=%222%22 d=%22M19 9l-7 7-7-7%22/%3E%3C/svg%3E'); background-repeat: no-repeat; background-position: right 0.5rem center; background-size: 1.5em 1.5em;"
                >
                  <option value="priority">Populair</option>
                  <option value="name">Naam</option>
                  <option value="newest">Nieuwste</option>
                </select>
              </div>
            </div>
          </div>

          <!-- Loading State -->
          <div v-if="loading" class="flex items-center justify-center h-64">
            <div
              class="animate-spin rounded-full h-12 w-12 border-b-2 border-theme"
            ></div>
          </div>

          <!-- Error State -->
          <div
            v-else-if="error"
            class="bg-red-50 border border-red-200 rounded-lg p-6 text-center"
          >
            <p class="text-red-600">
              Er is een fout opgetreden bij het laden van de producten.
            </p>
            <button
              @click="loadVacations"
              class="mt-4 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
            >
              Opnieuw proberen
            </button>
          </div>

          <!-- Results Grid -->
          <div
            v-else-if="filteredVacations.length > 0"
            class="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8"
          >
            <VacationCard
              v-for="vacation in paginatedVacations"
              :key="vacation.id"
              :vacation="vacation"
              @click="openVacationPreview"
            />
          </div>

          <!-- No Results -->
          <div v-else class="bg-white rounded-lg shadow-sm p-12 text-center">
            <div class="text-gray-400 mb-4">
              <svg
                class="mx-auto h-16 w-16"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 15c-2.34 0-4.29-1.009-5.664-2.409M15 7a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            </div>
            <h3 class="text-xl font-medium text-gray-900 mb-2">
              Geen producten gevonden
            </h3>
            <p class="text-gray-600 mb-6">
              Probeer uw filters aan te passen om meer producten te vinden.
            </p>
            <button
              @click="clearAllFilters"
              class="px-6 py-3 bg-theme text-white rounded-md hover:bg-theme-hover transition-colors"
            >
              Filters wissen
            </button>
          </div>

          <!-- Pagination -->
          <div
            v-if="filteredVacations.length > itemsPerPage"
            class="mt-8 flex justify-center"
          >
            <nav class="flex items-center space-x-2">
              <button
                @click="goToPage(Math.max(1, currentPage - 1))"
                :disabled="currentPage === 1"
                class="px-4 py-2 text-sm text-gray-500 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                ← Vorige
              </button>
              <span
                v-for="page in visiblePages"
                :key="page"
                @click="goToPage(page)"
                :class="[
                  'px-4 py-2 text-sm cursor-pointer rounded-md',
                  currentPage === page
                    ? 'bg-theme text-white'
                    : 'text-gray-700 hover:bg-gray-100',
                ]"
              >
                {{ page }}
              </span>
              <button
                @click="goToPage(Math.min(totalPages, currentPage + 1))"
                :disabled="currentPage === totalPages"
                class="px-4 py-2 text-sm text-gray-500 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Volgende →
              </button>
            </nav>
          </div>
        </div>
      </div>
    </div>

    <!-- HTML Preview Modal -->
    <div
      v-if="showPreviewModal"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-0 sm:p-4 modal-overlay"
      @click="closePreviewModal"
    >
      <div
        class="bg-white rounded-lg w-full h-full max-w-[1200px] max-h-[95vh] sm:max-h-[90vh] overflow-hidden flex flex-col"
        @click.stop
      >
        <!-- Modal Header -->
        <div class="flex justify-between items-center p-3 sm:p-4">
          <div class="flex-1 min-w-0">
            <h3 class="text-base sm:text-lg font-semibold text-gray-900 truncate">
              {{ selectedVacation?.metadata?.title || selectedVacation?.name }}
            </h3>
          </div>
          <button
            @click="closePreviewModal"
            class="ml-3 p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-200 rounded-full transition-colors flex-shrink-0"
          >
            <svg
              class="h-5 w-5 sm:h-6 sm:w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <!-- Modal Content -->
        <div class="flex-1 overflow-hidden">
          <!-- Loading State -->
          <div
            v-if="previewLoading"
            class="flex items-center justify-center h-full"
          >
            <div class="text-center">
              <div
                class="animate-spin rounded-full h-12 w-12 border-b-2 border-theme mx-auto mb-4"
              ></div>
              <p class="text-gray-600">Preview wordt geladen...</p>
            </div>
          </div>

          <!-- Error State -->
          <div
            v-else-if="previewError"
            class="flex items-center justify-center h-full"
          >
            <div class="text-center p-8">
              <svg
                class="mx-auto h-16 w-16 text-red-400 mb-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L5.232 15.5c-.77.833.192 2.5 1.732 2.5z"
                />
              </svg>
              <h4 class="text-lg font-medium text-gray-900 mb-2">
                Preview niet beschikbaar
              </h4>
              <p class="text-gray-600">
                Er is een fout opgetreden bij het laden van de preview.
              </p>
            </div>
          </div>

          <!-- Preview Content -->
          <iframe
            v-else-if="previewHtml"
            :srcdoc="previewHtml"
            class="w-full h-full border-0"
            frameborder="0"
            @load="onIframeLoad"
          ></iframe>
        </div>

        <!-- Modal Footer -->
        <div class="p-3 sm:p-4 border-t bg-gray-50">
          <!-- Mobile Layout -->
          <div class="sm:hidden">
            <!-- Categories -->
            <div class="mb-4">
              <div class="flex flex-wrap gap-2">
                <span
                  v-for="category in limitedCategories.visible"
                  :key="category"
                  class="bg-theme-light text-theme text-xs px-2 py-1 rounded-full"
                >
                  {{ formatCategory(category) }}
                </span>
                <button
                  v-if="limitedCategories.hasMore"
                  @click="toggleShowAllCategories"
                  class="bg-gray-200 text-gray-600 text-xs px-2 py-1 rounded-full hover:bg-gray-300 transition-colors"
                >
                  {{ showAllCategories ? 'Minder' : `+${limitedCategories.remaining} meer` }}
                </button>
              </div>
            </div>
            
            <!-- Buttons -->
            <div class="flex flex-col gap-4">
              <button
                @click="openExternalPreview"
                class="w-full px-4 py-3 text-blue-600 border border-blue-300 rounded-md hover:bg-blue-50 transition-colors uppercase text-sm"
              >
                <svg class="h-4 w-4 inline mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
                Open extern
              </button>
              <button
                @click="closePreviewModal"
                class="w-full px-4 py-3 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors uppercase text-sm"
              >
                Sluiten
              </button>
              <button
                v-if="showCTA"
                @click="handleCTA(selectedVacation)"
                class="w-full px-6 py-3 bg-theme text-white rounded-md hover:bg-theme-hover transition-colors uppercase font-bold text-sm"
              >
                {{ shopSettings.ctaText }}
              </button>
            </div>
          </div>

          <!-- Desktop Layout -->
          <div class="hidden sm:flex justify-between items-center">
            <div class="flex flex-wrap gap-2 flex-1 mr-4">
              <span
                v-for="category in limitedCategories.visible"
                :key="category"
                class="bg-theme-light text-theme text-sm px-3 py-1.5 rounded-full"
              >
                {{ formatCategory(category) }}
              </span>
              <button
                v-if="limitedCategories.hasMore"
                @click="toggleShowAllCategories"
                class="bg-gray-200 text-gray-600 text-sm px-3 py-1.5 rounded-full hover:bg-gray-300 transition-colors"
              >
                {{ showAllCategories ? 'Minder' : `+${limitedCategories.remaining} meer` }}
              </button>
            </div>
            <div class="flex space-x-3 flex-shrink-0">
            
              <button
                @click="closePreviewModal"
                class="px-4 py-2 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors uppercase"
              >
                Sluiten
              </button>
              <button
                v-if="showCTA"
                @click="handleCTA(selectedVacation)"
                class="px-6 py-2 bg-theme text-white rounded-md hover:bg-theme-hover transition-colors uppercase font-bold"
              >
                {{ shopSettings.ctaText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- External Image Preview Modal -->
    <div
      v-if="showImagePreview"
      class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center p-4 z-[10000] image-preview-overlay"
      @click="closeImagePreview"
    >
      <div class="relative max-w-[90vw] max-h-[90vh] flex items-center justify-center">
        <!-- Close button -->
        <button
          @click="closeImagePreview"
          class="absolute top-4 right-4 text-white hover:text-gray-300 bg-black bg-opacity-50 rounded-full p-2 z-10"
        >
          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        
        <!-- Image -->
        <img
          :src="previewImageUrl"
          alt="Image Preview"
          class="max-w-full max-h-full object-contain rounded-lg shadow-2xl"
          @click.stop
        />
        
        <!-- Download/Open button -->
        <a
          :href="previewImageUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="absolute bottom-4 right-4 bg-[#009DE2] hover:bg-[#009DE2] text-white px-4 py-2 rounded-lg shadow-lg transition-colors"
          @click.stop
        >
          <svg class="h-4 w-4 inline mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
          Open Full Size
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import UTDService from "@/services/UTDService";
import VacationCard from "@/components/VacationCard.vue";
import FilterSidebar from "@/components/FilterSidebar.vue";
import Handlebars from "handlebars";

export default {
  name: "VacationBooking",
  components: {
    VacationCard,
    FilterSidebar,
  },
  data() {
    return {
      // Loading and error states
      loading: false,
      error: false,

      // Data
      vacations: [],
      selectedVacation: null,

      // Preview modal
      showPreviewModal: false,
      previewLoading: false,
      previewError: false,
      previewHtml: "",

      // Image preview (outside modal)
      showImagePreview: false,
      previewImageUrl: "",

      // Filter state for accessories
      filters: {
        searchQuery: "",
        selectedCategories: [], // Single unified category selection
      },

      lang: this.shopSettings.lang || "nl",

      // Pagination and sorting
      currentPage: 1,
      itemsPerPage: 16,
      sortBy: "priority",

      // Mobile filter state
      showMobileFilters: false,

      // Category display state
      showAllCategories: false,
      maxVisibleCategories: 3, // Max categories to show initially

      // First load state
      isFirstLoad: true
    };
  },

  computed: {
    filteredVacations() {
      let filtered = this.vacations;

      // No hidden filters needed for accessories

      // Search filter - includes title, name, categories, and product code
      if (this.filters.searchQuery) {
        const query = this.filters.searchQuery.toLowerCase().trim();
        filtered = filtered.filter(
          (vacation) => {
            // Search in title
            if (vacation.metadata.title && vacation.metadata.title.toLowerCase().includes(query)) {
              return true;
            }
            // Search in name
            if (vacation.name && vacation.name.toLowerCase().includes(query)) {
              return true;
            }
            // Search in categories
            if (vacation.metadata.categories && vacation.metadata.categories.some((cat) =>
              cat.toLowerCase().includes(query)
            )) {
              return true;
            }
            // Search in product code/number - check both locationPageMeta and direct properties
            // Using underscore notation (product_code) as per actual API data structure
            const productCode = vacation.locationPageMeta?.product_code || 
                               vacation.locationPageMeta?.product_name || 
                               vacation.locationPageMeta?.productnummer || 
                               vacation.locationPageMeta?.artikelnummer ||
                               vacation.product_code ||
                               vacation.product_name;
            
            if (productCode && productCode.toString().toLowerCase().includes(query)) {
              return true;
            }
            // Search in description
            if (vacation.metadata.description && vacation.metadata.description.toLowerCase().includes(query)) {
              return true;
            }
            return false;
          }
        );
      }

      // Unified category filter
      if (this.filters.selectedCategories.length > 0) {
        filtered = filtered.filter((vacation) =>
          this.filters.selectedCategories.some((selectedCategory) => {
            // Check if vacation has this category
            const hasCategory = vacation.metadata.categories.some((cat) => {
              const lowerCat = cat.toLowerCase();
              const lowerSelected = selectedCategory.toLowerCase();
              
              // Direct match
              if (lowerCat === lowerSelected) return true;
              
              // Handle beeltenis variations - map back to original names
              if (lowerSelected.includes('(beeltenis)')) {
                const baseAnimal = lowerSelected.replace(' (beeltenis)', '');
                if (lowerCat === baseAnimal) return true;
              }
              
              // Handle fotokader special cases
              if (lowerSelected === 'met asruimte' || lowerSelected === 'zonder asruimte') {
                if (lowerCat === 'fotokader') return true;
              }
              
              return false;
            });
            
            return hasCategory;
          })
        );
      }

      // Sort results
      console.log('🔍 SORTING DEBUG:', {
        sortBy: this.sortBy,
        isFirstLoad: this.isFirstLoad,
        totalProducts: filtered.length,
        firstThreeProducts: filtered.slice(0, 3).map(v => ({
          name: v.name,
          metadataTitle: v.metadata?.title,
          id: v.id,
          orderPriority: v.orderPriority
        }))
      });

      if (this.sortBy === "name") {
        // Sort alphabetically by title or name (fallback)
        console.log('📝 Sorting by NAME (A-Z)');
        filtered.sort((a, b) => {
          // Clean up titles: remove tabs, newlines, extra spaces
          const cleanTitle = (title) => {
            return (title || '')
              .replace(/[\t\n\r]/g, ' ')  // Replace tabs and newlines with space
              .replace(/\s+/g, ' ')        // Replace multiple spaces with single space
              .trim()                      // Remove leading/trailing whitespace
              .toLowerCase();              // Case-insensitive comparison
          };
          
          const aTitle = cleanTitle(a.metadata?.title || a.name);
          const bTitle = cleanTitle(b.metadata?.title || b.name);
          return aTitle.localeCompare(bTitle);
        });
      } else if (this.sortBy === "newest") {
        // Sort by newest first (higher ID = newer)
        console.log('🆕 Sorting by NEWEST (highest ID first)');
        filtered.sort((a, b) => b.id - a.id);
      } else if (this.sortBy === "priority") {
        // Sort by popularity/priority
        // 1. "populair" products first
        // 2. Then by orderPriority (highest first)
        console.log('⭐ Sorting by PRIORITY (populair first, then highest orderPriority)');
        filtered.sort((a, b) => {
          // Check if product has "populair" category
          const aInKijker = a.metadata?.categories?.some(cat => 
            cat.toLowerCase() === 'populair'
          ) || false;
          const bInKijker = b.metadata?.categories?.some(cat => 
            cat.toLowerCase() === 'populair'
          ) || false;
          
          // If one has "populair" and the other doesn't, prioritize the one with it
          if (aInKijker && !bInKijker) return -1;
          if (!aInKijker && bInKijker) return 1;
          
          // Both have or both don't have "populair", sort by orderPriority
          // Treat null/undefined as -1 so they appear LAST
          const aPriority = (a.orderPriority !== null && a.orderPriority !== undefined) ? a.orderPriority : -1;
          const bPriority = (b.orderPriority !== null && b.orderPriority !== undefined) ? b.orderPriority : -1;
          
          // Higher priority number = higher popularity (100 is more popular than 10)
          return bPriority - aPriority;
        });
      } else if (this.isFirstLoad) {
        // Randomize on first load only if no sort is selected
        console.log('🎲 RANDOMIZING (first load)');
        filtered = this.shuffleArray([...filtered]);
      }

      console.log('✅ AFTER SORTING - First 5 products:', filtered.slice(0, 5).map(v => ({
        name: v.name,
        metadataTitle: v.metadata?.title,
        displayTitle: v.metadata?.title || v.name,
        id: v.id,
        orderPriority: v.orderPriority
      })));

      return filtered;
    },

    paginatedVacations() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      // remove vakanties in metadata.categories just dont include the label vakanties
      const updatedVacations = this.filteredVacations.map(vacation => {
        return {
          ...vacation,
          metadata: {
            ...vacation.metadata,
            categories: vacation.metadata.categories.filter(category => category !== 'vakanties')
          }
        }
      });
      return updatedVacations.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.filteredVacations.length / this.itemsPerPage);
    },

    visiblePages() {
      const totalVisible = 5;
      const half = Math.floor(totalVisible / 2);
      let start = Math.max(1, this.currentPage - half);
      let end = Math.min(this.totalPages, start + totalVisible - 1);

      if (end - start + 1 < totalVisible) {
        start = Math.max(1, end - totalVisible + 1);
      }

      const pages = [];
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },

    activeFiltersText() {
      const filters = [];
      if (this.filters.searchQuery)
        filters.push(`"${this.filters.searchQuery}"`);
      if (this.filters.selectedCategories.length > 0)
        filters.push(`${this.filters.selectedCategories.length} categorie${this.filters.selectedCategories.length > 1 ? 'ën' : ''}`);

      if (filters.length === 0) return "Alle producten";
      return `Gefilterd op: ${filters.join(", ")}`;
    },

    activeFilterCount() {
      let count = 0;
      
      if (this.filters.searchQuery) count++;
      if (this.filters.selectedCategories.length > 0) count++;
      
      return count;
    },

    displayVacationCount() {
      // On first load, show total product count to give impression of full catalog
      // Once user applies filters, show actual filtered count
      if (this.isFirstLoad) {
        return this.vacations.length;
      }
      return this.filteredVacations.length;
    },

    limitedCategories() {
      const allCategories = this.selectedVacation?.metadata?.categories || [];
      const hideLabels = this.shopSettings?.hideLabels || [];
      
      // Filter out hidden labels
      const categories = allCategories.filter(category => 
        !hideLabels.includes(category.toLowerCase())
      );
      
      const total = categories.length;
      
      if (this.showAllCategories || total <= this.maxVisibleCategories) {
        return {
          visible: categories,
          hasMore: false,
          remaining: 0
        };
      }
      
      return {
        visible: categories.slice(0, this.maxVisibleCategories),
        hasMore: true,
        remaining: total - this.maxVisibleCategories
      };
    },

    showAgentFinder() {
      // Show agent finder button if URL parameter is present
      return this.$route.query['show-agent-finder'] === 'true' || 
             this.$route.query['agent-finder'] === 'true' ||
             this.$route.query['show-agents'] === 'true' ||
             this.$route.query['office'] === 'true';
    },

    showHeader() {
      // Hide header if URL parameter is present
      const urlHideHeader = this.$route.query['hide-header'] === 'true';
      const urlNoHeader = this.$route.query['no-header'] === 'true';
      const urlHeadless = this.$route.query['headless'] === 'true';
      const dataNoHeader = this.shopSettings.noHeader === 'true';
      
      return !urlHideHeader && !urlNoHeader && !urlHeadless && !dataNoHeader;
    },

    showCTA() {
      // Hide CTA buttons if URL parameter is present
      return this.$route.query['hide-cta'] !== 'true' && 
             this.$route.query['no-cta'] !== 'true' &&
             this.$route.query['hide-buttons'] !== 'true' &&
             this.$route.query['no-buttons'] !== 'true';
    },
  },

  watch: {
    // Reset pagination when filters change
    filters: {
      handler() {
        this.currentPage = 1;
        // Update URL when filters change (but not on first load)
        if (!this.isFirstLoad) {
          this.updateUrlFromFilters();
        }
      },
      deep: true,
    },

    // Watch for sort changes
    sortBy(newValue, oldValue) {
      // When user changes sort, it's no longer first load
      console.log('🔄 SORT CHANGED:', { from: oldValue, to: newValue });
      this.isFirstLoad = false;
      this.currentPage = 1;
      this.scrollToTop();
    },

    // Watch for URL changes (browser back/forward)
    '$route.query': {
      handler(newQuery) {
        // Only update filters if not first load to avoid conflicts
        if (!this.isFirstLoad) {
          this.updateFiltersFromUrl();
        }
      },
      deep: true,
    },
  },

  async created() {
    await this.loadVacations();
    
    // Check if URL has filter parameters (means it's not a fresh first load)
    const hasUrlFilters = this.hasFilterParametersInUrl();
    
    if (hasUrlFilters) {
      // If URL has filters, load them and disable first load behavior
      this.isFirstLoad = false;
      this.updateFiltersFromUrl();
    } else {
      // First load: show all accessories without filters
      this.isFirstLoad = true;
    }

    // Listen for messages from iframe (for image clicks)
    window.addEventListener('message', this.handleIframeMessage);
  },

  beforeDestroy() {
    // Clean up event listener
    window.removeEventListener('message', this.handleIframeMessage);
  },

  methods: {
    async loadVacations() {
      this.loading = true;
      this.error = false;

      try {
        this.vacations = await UTDService.getProducts(this.shopSettings.label, this.shopSettings.lang, this.shopSettings.siteId);
      } catch (error) {
        console.error("Error loading products:", error);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },

    onFilterChange(filterUpdates) {
      // Any filter change means it's no longer first load
      this.isFirstLoad = false;
      
      this.filters = { ...this.filters, ...filterUpdates };
      this.scrollToTop();
      // Auto-close mobile filters when a filter is applied for better UX
      if (this.showMobileFilters) {
        setTimeout(() => {
          this.closeMobileFilters();
        }, 300); // Small delay for better UX
      }
    },

    clearAllFilters() {
      // Clearing filters means it's no longer first load
      this.isFirstLoad = false;
      
      this.filters = {
        searchQuery: "",
        selectedCategories: [],
      };
      this.currentPage = 1;
      this.scrollToTop();
    },

    async openVacationPreview(vacation) {
      let siteId = this.shopSettings.siteId;
      console.log("siteId", siteId);
      this.selectedVacation = vacation;
      this.showPreviewModal = true;
      this.previewLoading = true;
      this.previewError = false;
      this.previewHtml = "";

      // Add body class for modal state
      document.body.classList.add('modal-open', 'preview-modal-open');

      try {
        const response = await fetch(
          `https://www.uptodateconnect.com/api/v1/site-builder/sites-page-html-export?siteId=${siteId}&pageId=${vacation.pageId}`
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const htmlContent = await response.text();
        

        // Replace localhost URLs with the proper domain using dynamic baseUrl
        const processedHtml = htmlContent
        .replace(/http:\/\/selectair-vakanties.uptodatesites.com/g, this.shopSettings.baseUrl)
        .replace(/href="\/p\//g, `href="${this.shopSettings.baseUrl}/p/`)
        // Handle external images - remove crossorigin to avoid CORS issues
        .replace(/crossorigin="[^"]*"/g, '')
        // .replace(/src="\/uploads\//g, `src="${this.shopSettings.baseUrl}/uploads/`)
        // .replace(/src="\/assets\//g, `src="${this.shopSettings.baseUrl}/assets/`);

        console.log("vacation", vacation.locationPageMeta);

        // Register Handlebars helpers for proper formatting
        Handlebars.registerHelper('formatProductCode', function(code) {
          return code ? `Product code: ${code}` : '';
        });
        
        Handlebars.registerHelper('formatVolume', function(volume) {
          if (!volume) return '';
          const cleanVolume = parseFloat(volume);
          if (isNaN(cleanVolume)) return `Formaat: ${volume}`;
          return `Formaat: ${cleanVolume} liter`;
        });
        
        Handlebars.registerHelper('formatPersonalizable', function(personalizable) {
          return personalizable ? `Personaliseerbaar: ${personalizable}` : '';
        });

        // Helper to add colon and space formatting
        Handlebars.registerHelper('withColon', function(label, value) {
          return value ? `${label}: ${value}` : '';
        });

        // Helper for image galleries
        Handlebars.registerHelper('imageGallery', function(images) {
          if (!images || !Array.isArray(images)) return '';
          
          return images.map(img => 
            `<div class="gallery-image">
              <img src="${img.url}" alt="${img.alt || ''}" loading="lazy" />
            </div>`
          ).join('');
        });

        // Helper for main product image
        Handlebars.registerHelper('mainImage', function(image) {
          if (!image) return '';
          return `<div class="image-container">
            <img src="${image}" alt="Product Image" loading="lazy" />
          </div>`;
        });

        // Use Handlebars to replace the content of the html with product data
        const template = Handlebars.compile(processedHtml);
        const processedWithHandlebars = template({
          baseUrl: this.shopSettings.baseUrl,
          ...vacation.locationPageMeta,
          name: vacation.name,
        });

        this.previewHtml =
          `
          <link href='https://fonts.googleapis.com/css?family=Josefin+Sans:400,400i,600,600i' id='selected-fonts' rel='stylesheet' type='text/css'/>
          <link href='https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css' rel='stylesheet' type='text/css'/>
          <link href='https://uptodatewebdesign.s3.eu-west-3.amazonaws.com/cdn/dist/v2/app.min.css' rel='stylesheet' type='text/css'/>
<style>
  :root {
  	--body-font: 'Jost', sans-serif;
  	--title-font: 'Lexend', sans-serif;
  	--light-theme: #effaff;
  	--dark-theme: #007aaf;
  	--post-image-padding: 14rem 0;
  	--gray-86: #e8e8ed;
  	--agro: #38a933;
  	--infra: #f59c00;
  	--modulo: #d34752;
  	--light-agro: #38a93321;
  	--light-infra: #f59c0029;
  	--light-modulo: #d3475229;
  }
  
  body {
  	color: var(--body-font-color);
  	font-family: var(--body-font);
  }


  
  /* BUTTONS */
  .button-blue,
  .button-white-stroke,
  .button-blue-stroke,
  .button-mailchimp,
  .post--in-out-style .post__read-more a,
  .post--faq-style .post__meta .post__read-more a,
  .in-de-kijker .post__read-more a {
  	position: relative;
    z-index: 2;
    overflow: hidden;
    vertical-align: middle;
    display: inline-block;
    text-transform: uppercase;
    text-align: center;
    background-color: var(--theme);
    color: var(--white);
    line-height: 1;
  	padding: 1.75rem 2rem;
  	border: 1px solid var(--theme);
		border-radius: 0;
  }
  
  .post--faq-style .post__meta .post__read-more a {
  	padding: 1rem 1.2rem;
  }
  
  .button-white-stroke {
  	background-color: transparent;
  	border: 1px solid var(--white);
  }
  
  .button-blue-stroke {
  	background-color: transparent;
  	border: 1px solid var(--theme);
  	color: var(--theme);
  }
  
  .button-mailchimp {
  	background-color: var(--theme-hover);
  	border: 1px solid var(--theme-hover);
  }
  
  .button-blue:before,
  .button-blue:after,
  .button-white-stroke:before,
  .button-white-stroke:after,
  .button-blue-stroke:before,
  .button-blue-stroke:after,
  .button-mailchimp:before,
  .button-mailchimp:after,
  .post--in-out-style .post__read-more a:before,
  .post--in-out-style .post__read-more a:after,
  .post--faq-style .post__meta .post__read-more a:before,
  .post--faq-style .post__meta .post__read-more a:after,
  .in-de-kijker .post__read-more a:before,
  .in-de-kijker .post__read-more a:after {
  	content: "";
    position: absolute;
    height: 100%;
    top: 0;
    width: 0%;
    background-color: var(--theme-hover);
    z-index: -1;
    -webkit-transition: all 0.4s ease-out;
    transition: all 0.4s ease-out;
  }
  
  .button-mailchimp:before,
  .button-mailchimp:after {
    background-color: var(--dark-theme);
  }
  
  .button-blue:before,
  .button-white-stroke:before,
  .button-blue-stroke:before,
  .button-mailchimp:before,
  .post--in-out-style .post__read-more a:before,
  .post--faq-style .post__meta .post__read-more a:before,
  .in-de-kijker .post__read-more a:before {
  	left: 0;
  }
  
  .button-blue:after,
  .button-white-stroke:after,
  .button-blue-stroke:after,
  .button-mailchimp:after,
  .post--in-out-style .post__read-more a:after,
  .post--faq-style .post__meta .post__read-more a:after,
  .in-de-kijker .post__read-more a:after {
  	right: 0;
  }
  
  .button-blue:hover::before,
  .button-blue:hover::after,
  .button-white-stroke:hover::before,
  .button-white-stroke:hover::after,
  .button-blue-stroke:hover::before,
  .button-blue-stroke:hover::after,
  .button-mailchimp:hover::before,
  .button-mailchimp:hover::after,
  .post--in-out-style .post__read-more a:hover:before,
  .post--in-out-style .post__read-more a:hover:after,
  .post--faq-style .post__meta .post__read-more a:hover:before,
  .post--faq-style .post__meta .post__read-more a:hover:after,
  .in-de-kijker .post__read-more a:hover:before,
  .in-de-kijker .post__read-more a:hover:after {
  	width: 50%;
    border-radius: 0;
  }
  
  .button-blue:hover,
  .button-white-stroke:hover,
  .button-blue-stroke:hover,
  .post--in-out-style .post__read-more a:hover,
  .post--faq-style .post__meta .post__read-more a:hover,
  .in-de-kijker .post__read-more a:hover {
  	border: 1px solid var(--theme-hover) !important;
  }
  
  .button-mailchimp:hover {
  	border: 1px solid var(--dark-theme) !important;
  }
  
  .button-white-stroke:hover,
  .button-blue-stroke:hover,
  .button-mailchimp:hover,
  .post--in-out-style .post__read-more a:hover {
  	color: var(--white) !important;
  }
  

          </style> ${processedWithHandlebars}
          <script>
            var utdElementSiteUrl = '${siteId}';
            var BLOGGER_URL = '/';
          <\/script>
          <script src='https://unpkg.com/swiper@6.1.2/swiper-bundle.min.js'><\/script>
          <script src='https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js'><\/script>
          <script src='https://uptodatewebdesign.s3.eu-west-3.amazonaws.com/cdn/dist/v2/app.min.js'><\/script>
        `
      } catch (error) {
        console.error("Error loading preview:", error);
        this.previewError = true;
      } finally {
        this.previewLoading = false;
      }
    },

    closePreviewModal() {
      this.showPreviewModal = false;
      this.selectedVacation = null;
      this.previewHtml = "";
      this.previewError = false;
      this.showAllCategories = false; // Reset category display state
      
      // Remove body classes for modal state
      document.body.classList.remove('modal-open', 'preview-modal-open');
    },

    openExternalPreview() {
      if (this.selectedVacation) {
        // Open the original product page in a new tab
        const productUrl = `${this.shopSettings.baseUrl}${this.selectedVacation.bloggerPageUrl}`;
        window.open(productUrl, '_blank');
      }
    },

    handleIframeMessage(event) {
      // Only handle messages from our iframe
      if (event.data && event.data.source === 'selectair-iframe') {
        console.log('📨 Message received from iframe:', event.data);
        
        if (event.data.type === 'imageClick') {
          const { imageUrl, alt, title } = event.data.data;
          
          // Show image preview outside the modal
          this.previewImageUrl = imageUrl;
          this.showImagePreview = true;
          
          // Add body class for image preview state
          document.body.classList.add('image-preview-open');
          
          console.log('🖼️ Opening image preview:', imageUrl);
        }
      }
    },

    closeImagePreview() {
      this.showImagePreview = false;
      this.previewImageUrl = "";
      
      // Remove body class for image preview state
      document.body.classList.remove('image-preview-open');
    },

    toggleShowAllCategories() {
      this.showAllCategories = !this.showAllCategories;
    },

        onIframeLoad() {
      console.log("🔥 onIframeLoad called");
      
      // Check if the main app is running inside an iframe
      const isInIframe = window.self !== window.top;
      console.log("🖼️ App is in iframe:", isInIframe);
      
      // Simple approach: just open the current vacation page on any click
      const iframe = document.querySelector("iframe");
      console.log("🖼️ Iframe found:", !!iframe);
      
      if (iframe && iframe.contentDocument) {
        console.log("📄 Iframe contentDocument found, injecting simple click handler...");
        
        // Check if script was already injected to prevent duplicates
        if (iframe.contentDocument.getElementById('selectair-simple-handler')) {
          console.log("⚠️ Script already injected, skipping");
          return;
        }
        
        const script = iframe.contentDocument.createElement("script");
        script.id = 'selectair-simple-handler';
        script.textContent = `
          console.log("🚀 Image click handler with parent communication injected");
          
          // Function to send message to parent window
          function sendToParent(type, data) {
            window.parent.postMessage({
              type: type,
              data: data,
              source: 'selectair-iframe'
            }, '*');
          }
          
          // Special handling for images vs other content
          document.addEventListener('click', function(e) {
            console.log("🔥 Click detected in iframe:", e.target);
            
            // If clicking on an image, emit to parent for external preview
            if (e.target.tagName === 'IMG') {
              console.log("🖼️ Image clicked:", e.target.src);
              
              if (e.target.src) {
                e.preventDefault();
                e.stopPropagation();
                
                // Send image URL to parent for external preview
                sendToParent('imageClick', {
                  imageUrl: e.target.src,
                  alt: e.target.alt || '',
                  title: e.target.title || ''
                });
                
                console.log("📤 Image click sent to parent:", e.target.src);
                return false;
              }
            }
            
            // For non-image clicks, only respond to actual links
            // Be very restrictive - only links and buttons should open main site
            const isActualLink = 
              e.target.tagName === 'A' || 
              e.target.tagName === 'BUTTON' ||
              // Check if clicked element is inside a link
              e.target.closest('a') !== null ||
              e.target.closest('button') !== null;
            
            if (isActualLink) {
              console.log("🔗 Link/button clicked, opening main site:", e.target.tagName);
              
              // Prevent default behavior
              e.preventDefault();
              e.stopPropagation();
              
              // Build target URL with tracking
              const baseUrl = '${this.shopSettings.baseUrl}';
              const productUrl = baseUrl + '${this.selectedVacation?.bloggerPageUrl || ''}';
              console.log("🎯 Opening product page:", productUrl);
              
              // Open in new tab
              window.open(productUrl, '_blank');
              
              return false;
            } else {
              console.log("👆 Click ignored - not on image or link");
            }
          }, true); // Use capture phase to catch all clicks
          
          // Make all images clickable and add hover effects
          const images = document.querySelectorAll('img');
          images.forEach(img => {
            img.style.cursor = 'pointer';
            img.style.transition = 'transform 0.2s ease';
            
            // Remove any crossorigin attributes that might cause CORS issues
            img.removeAttribute('crossorigin');
            
            img.addEventListener('mouseenter', function() {
              this.style.transform = 'scale(1.02)';
            });
            img.addEventListener('mouseleave', function() {
              this.style.transform = 'scale(1)';
            });
          });
          
          console.log("✅ Image handler with parent communication ready");
        `;
        
        iframe.contentDocument.head.appendChild(script);
        console.log("✅ Simple script injected successfully");
        
        // Emit event for future handling
        this.$emit('iframe-click-handler-ready', {
          vacation: this.selectedVacation,
          baseUrl: this.shopSettings.baseUrl
        });
        
      } else {
        console.log("❌ Could not access iframe contentDocument");
      }

      console.log("🏁 Preview loaded successfully - behavior depends on iframe context");
    },

    handleCTA(vacation) {
      const ctaUrl = this.shopSettings.ctaUrl;
      
      // If CTA URL is provided and not just a placeholder, handle it
      if (ctaUrl && ctaUrl !== "#") {
        // Check if it's an external URL
        if (ctaUrl.startsWith('http://') || ctaUrl.startsWith('https://')) {
          // Open external URL in new tab
          window.open(ctaUrl, '_blank');
        } else if (ctaUrl.startsWith('mailto:')) {
          // Handle mailto links
          window.location.href = ctaUrl;
        } else {
          // Handle internal URLs
          window.location.href = ctaUrl;
        }
        
        // Close modal after CTA action
        this.closePreviewModal();
      } else {
        // Fallback behavior for when no URL is configured
        alert(
          `${this.shopSettings.ctaText} voor "${vacation.metadata.title}" - Deze functionaliteit wordt nog geïmplementeerd.`
        );
        this.closePreviewModal();
      }
    },

    // Keep the old method for backward compatibility if needed elsewhere
    bookVacation(vacation) {
      this.handleCTA(vacation);
    },

    formatCategory(category) {
      return category.charAt(0).toUpperCase() + category.slice(1);
    },

    toggleMobileFilters() {
      this.showMobileFilters = !this.showMobileFilters;
    },

    closeMobileFilters() {
      this.showMobileFilters = false;
    },

    goToPage(page) {
      this.currentPage = page;
      this.scrollToTop();
    },

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },

    // First load behavior


    shuffleArray(array) {
      const shuffled = [...array];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    },

    // URL State Management
    hasFilterParametersInUrl() {
      const query = this.$route.query;
      const filterParams = [
        'search', 'categories'
      ];
      return filterParams.some(param => query[param]);
    },

    updateUrlFromFilters() {
      const query = { ...this.$route.query }; // Preserve existing params like siteId, baseUrl, etc.
      
      // Remove old filter params
      delete query.search;
      delete query.categories;
      
      // Add current filter values
      if (this.filters.searchQuery) {
        query.search = this.filters.searchQuery;
      }
      
      if (this.filters.selectedCategories.length > 0) {
        query.categories = this.filters.selectedCategories.join(',');
      }
      
      // Update URL without triggering navigation
      this.$router.replace({ query }).catch(() => {
        // Ignore navigation failures (happens when query is same)
      });
    },

    updateFiltersFromUrl() {
      const query = this.$route.query;
      
      this.filters = {
        searchQuery: query.search || "",
        selectedCategories: query.categories ? query.categories.split(',').filter(Boolean) : [],
      };
      
      console.log("🔗 Updated filters from URL:", this.filters);
    },
  },
};
</script>

<style>
/* Scoped styles for SelectAir widget */
.custom-filter-page {
  --anders-beton-theme: #009DE2;
  --anders-beton-theme-hover: #585F65;
  --anders-beton-theme-light: #fef2f2;
  max-width: 1400px;
  margin: 0 auto;
}

/* Theme classes with scoped variables */
.custom-filter-page .bg-theme {
  background-color: var(--anders-beton-theme) !important;
}

.custom-filter-page .bg-theme-hover {
  background-color: var(--anders-beton-theme-hover) !important;
}

.custom-filter-page .bg-theme-light {
  background-color: var(--anders-beton-theme-light) !important;
}

.custom-filter-page .text-theme {
  color: var(--anders-beton-theme) !important;
}

.custom-filter-page .border-theme {
  border-color: var(--anders-beton-theme) !important;
}

/* Tailwind text size classes adjusted for 10px rem base */
.custom-filter-page .text-xs {
  font-size: 1.2rem !important; /* 12px */
  line-height: 1.6rem !important; /* 16px */
  font-weight: 300 !important;
}

.custom-filter-page .text-sm {
  font-size: 1.4rem !important; /* 14px */
  line-height: 2rem !important; /* 20px */
  font-weight: 300 !important;
}

.custom-filter-page .text-base {
  font-size: 1.6rem !important; /* 16px */
  line-height: 2.4rem !important; /* 24px */
}

.custom-filter-page .text-lg {
  font-size: 1.5rem !important; /* 18px */
  line-height: 2rem !important; /* 28px */
}

.custom-filter-page .text-xl {
  font-size: 2rem !important; /* 20px */
  line-height: 2.5rem !important; /* 28px */
}

.custom-filter-page .text-2xl {
  font-size: 2.4rem !important; /* 24px */
  line-height: 3.2rem !important; /* 32px */
}

.custom-filter-page .text-3xl {
  font-size: 3rem !important; /* 30px */
  line-height: 3.6rem !important; /* 36px */
}

/* Keep original text sizes for headings - don't override */
.custom-filter-page h1 {
  font-size: inherit;
}

.custom-filter-page h2 {
  font-size: inherit;
}

.custom-filter-page h3 {
  font-size: inherit;
}

/* Form elements - minimal fixes only */
.custom-filter-page input[type="text"],
.custom-filter-page input[type="email"],
.custom-filter-page input[type="tel"],
.custom-filter-page input[type="number"],
.custom-filter-page input[type="date"],
.custom-filter-page input[type="search"],
.custom-filter-page input[type="password"],
.custom-filter-page select,
.custom-filter-page textarea {
  font-size: 14px !important;
  background: white !important;
  border: 1px solid #d1d5db !important;
  border-radius: 6px !important;
  padding: 8px 12px !important;
}

.custom-filter-page select {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e") !important;
  background-position: right 8px center !important;
  background-repeat: no-repeat !important;
  background-size: 16px !important;
  padding-right: 40px !important;
}

/* Button styles - minimal */
.custom-filter-page button {
  font-size: 14px !important;
  border-radius: 6px !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
}

/* Labels */
.custom-filter-page label {
  font-size: 14px !important;
  font-weight: 500 !important;
}

/* Focus states */
.custom-filter-page input:focus,
.custom-filter-page select:focus,
.custom-filter-page textarea:focus {
  outline: none !important;
  border-color: var(--anders-beton-theme) !important;
  box-shadow: 0 0 0 3px rgba(227, 28, 24, 0.1) !important;
}

/* Modal z-index fix */
.custom-filter-page .modal-overlay {
  z-index: 9999 !important;
}

/* Image preview modal - highest z-index */
.custom-filter-page .image-preview-overlay {
  z-index: 10000 !important;
  backdrop-filter: blur(4px);
}

.custom-filter-page .image-preview-overlay img {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  max-width: 90vw;
  max-height: 90vh;
}

/* Line clamp utility */
.custom-filter-page .line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Prevent conflicts with external styles */
.custom-filter-page * {
  box-sizing: border-box;
}

/* Body classes for modal state control */
body.modal-open {
  /* Add any global styles when any modal is open */
}

body.preview-modal-open {
  /* Styles specific to product preview modal being open */
}

body.image-preview-open {
  /* Styles specific to image preview being open */
  /* Higher z-index control can be added here */
}
</style>
